module.exports = __webpack_public_path__ + "img/icon5.2d3f4b7d.png";